import React, { useState } from 'react';
import { Modal } from './ui/Modal';
export function Footer() {
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  return <footer className="bg-charcoal-dark border-t border-charcoal-light py-12" data-id="element-92">
      <div className="max-w-7xl mx-auto px-6 flex flex-col items-center text-center" data-id="element-93">
        <div className="mb-8" data-id="element-94">
          <h2 className="text-2xl font-heading font-bold tracking-widest text-offwhite" data-id="element-95">
            RESET <span className="text-sand" data-id="element-96">7D</span>
          </h2>
          <p className="text-offwhite-dim/60 mt-2 text-sm uppercase tracking-wider" data-id="element-97">
            Por Matías Sena
          </p>
        </div>

        <p className="text-sand font-medium italic mb-12" data-id="element-98">
          "No perfecto. Completo."
        </p>

        <div className="flex flex-wrap justify-center gap-6 text-sm text-offwhite-dim/50 mb-8" data-id="element-99">
          <button onClick={() => setIsPrivacyOpen(true)} className="hover:text-sand transition-colors" data-id="element-100">
            Política de Privacidad
          </button>
          <button onClick={() => setIsTermsOpen(true)} className="hover:text-sand transition-colors" data-id="element-101">
            Términos y Condiciones
          </button>
        </div>

        <p className="text-xs text-offwhite-dim/30" data-id="element-102">
          © {new Date().getFullYear()} Matías Sena. Todos los derechos
          reservados.
        </p>
      </div>

      {/* Privacy Modal */}
      <Modal isOpen={isPrivacyOpen} onClose={() => setIsPrivacyOpen(false)} title="Política de Privacidad" data-id="element-103">
        <p data-id="element-104">
          En RESET 7D, respetamos tu privacidad y nos comprometemos a proteger
          tus datos personales. Esta política describe cómo recopilamos, usamos
          y protegemos la información que nos proporcionas.
        </p>
        <h3 className="text-offwhite font-bold mt-4 mb-2" data-id="element-105">
          1. Información que recopilamos
        </h3>
        <p data-id="element-106">
          Solo recopilamos la información necesaria para brindarte el servicio
          de acompañamiento a través de WhatsApp, como tu número de teléfono y
          nombre.
        </p>
        <h3 className="text-offwhite font-bold mt-4 mb-2" data-id="element-107">
          2. Uso de la información
        </h3>
        <p data-id="element-108">
          Tu información se utiliza exclusivamente para enviarte el material del
          programa (PDF, Tracker) y para el seguimiento personalizado durante
          los 7 días.
        </p>
        <h3 className="text-offwhite font-bold mt-4 mb-2" data-id="element-109">
          3. Protección de datos
        </h3>
        <p data-id="element-110">
          No compartimos, vendemos ni alquilamos tu información personal a
          terceros bajo ninguna circunstancia.
        </p>
      </Modal>

      {/* Terms Modal */}
      <Modal isOpen={isTermsOpen} onClose={() => setIsTermsOpen(false)} title="Términos y Condiciones" data-id="element-111">
        <p data-id="element-112">
          Al unirte a RESET 7D, aceptas los siguientes términos y condiciones:
        </p>
        <h3 className="text-offwhite font-bold mt-4 mb-2" data-id="element-113">
          1. Naturaleza del Programa
        </h3>
        <p data-id="element-114">
          RESET 7D es un programa de acompañamiento y hábitos. No reemplaza el
          consejo médico profesional, diagnóstico o tratamiento. Siempre
          consulta a tu médico antes de comenzar cualquier régimen de dieta o
          ejercicio.
        </p>
        <h3 className="text-offwhite font-bold mt-4 mb-2" data-id="element-115">2. Compromiso</h3>
        <p data-id="element-116">
          El éxito del programa depende de tu compromiso durante los 7 días. El
          acompañamiento se realiza exclusivamente vía WhatsApp.
        </p>
        <h3 className="text-offwhite font-bold mt-4 mb-2" data-id="element-117">
          3. Propiedad Intelectual
        </h3>
        <p data-id="element-118">
          Todo el material entregado (PDFs, Trackers, metodologías) es propiedad
          intelectual de Matías Sena y es para tu uso personal exclusivo. Queda
          prohibida su distribución o venta.
        </p>
      </Modal>
    </footer>;
}